/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CotisationsBelgesHorsZoneIcDto } from '../models/cotisations-belges-hors-zone-ic-dto';
import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { LoadResult } from '../models/load-result';
import { PersonnesPhysiquesSecondeResidenceDto } from '../models/personnes-physiques-seconde-residence-dto';
import { SecondeResidencePersonnePhysiqueDto } from '../models/seconde-residence-personne-physique-dto';


/**
 * Fonctions de gestion des personnes physiques d'une seconde résidence
 */
@Injectable({
  providedIn: 'root',
})
export class PersonnesPhysiquesSecondeResidenceService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation personnesPhysiquesSecondeResidenceGetList
   */
  static readonly PersonnesPhysiquesSecondeResidenceGetListPath = '/api/personnes-physiques-seconde-residence/list/{secondeResidenceId}';

  /**
   * Renvoie la liste des personnes physiques de la seconde résidence spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `personnesPhysiquesSecondeResidenceGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  personnesPhysiquesSecondeResidenceGetList$Response(params: {

    /**
     * Identifiant de la seconde résidence
     */
    secondeResidenceId: number;
  }): Observable<StrictHttpResponse<Array<CotisationsBelgesHorsZoneIcDto>>> {

    const rb = new RequestBuilder(this.rootUrl, PersonnesPhysiquesSecondeResidenceService.PersonnesPhysiquesSecondeResidenceGetListPath, 'get');
    if (params) {
      rb.path('secondeResidenceId', params.secondeResidenceId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<CotisationsBelgesHorsZoneIcDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des personnes physiques de la seconde résidence spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `personnesPhysiquesSecondeResidenceGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  personnesPhysiquesSecondeResidenceGetList(params: {

    /**
     * Identifiant de la seconde résidence
     */
    secondeResidenceId: number;
  }): Observable<Array<CotisationsBelgesHorsZoneIcDto>> {

    return this.personnesPhysiquesSecondeResidenceGetList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<CotisationsBelgesHorsZoneIcDto>>) => r.body as Array<CotisationsBelgesHorsZoneIcDto>)
    );
  }

  /**
   * Path part for operation personnesPhysiquesSecondeResidenceLoadList
   */
  static readonly PersonnesPhysiquesSecondeResidenceLoadListPath = '/api/personnes-physiques-seconde-residence/load-list/{secondeResidenceId}';

  /**
   * Renvoie la liste des personnes physiques de la seconde résidence spécifiée (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `personnesPhysiquesSecondeResidenceLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  personnesPhysiquesSecondeResidenceLoadList$Response(params: {

    /**
     * Identifiant de la seconde résidence
     */
    secondeResidenceId: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, PersonnesPhysiquesSecondeResidenceService.PersonnesPhysiquesSecondeResidenceLoadListPath, 'post');
    if (params) {
      rb.path('secondeResidenceId', params.secondeResidenceId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des personnes physiques de la seconde résidence spécifiée (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `personnesPhysiquesSecondeResidenceLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  personnesPhysiquesSecondeResidenceLoadList(params: {

    /**
     * Identifiant de la seconde résidence
     */
    secondeResidenceId: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.personnesPhysiquesSecondeResidenceLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation personnesPhysiquesSecondeResidenceGet
   */
  static readonly PersonnesPhysiquesSecondeResidenceGetPath = '/api/personnes-physiques-seconde-residence/{secondeResidenceId}/{personnePhysiqueId}';

  /**
   * Renvoie la personne physique spécifiée dans la seconde résidence spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `personnesPhysiquesSecondeResidenceGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  personnesPhysiquesSecondeResidenceGet$Response(params: {

    /**
     * Identifiant de la seconde résidence
     */
    secondeResidenceId: number;

    /**
     * Identifiant de la personne physique
     */
    personnePhysiqueId: number;
  }): Observable<StrictHttpResponse<PersonnesPhysiquesSecondeResidenceDto>> {

    const rb = new RequestBuilder(this.rootUrl, PersonnesPhysiquesSecondeResidenceService.PersonnesPhysiquesSecondeResidenceGetPath, 'get');
    if (params) {
      rb.path('secondeResidenceId', params.secondeResidenceId, {});
      rb.path('personnePhysiqueId', params.personnePhysiqueId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PersonnesPhysiquesSecondeResidenceDto>;
      })
    );
  }

  /**
   * Renvoie la personne physique spécifiée dans la seconde résidence spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `personnesPhysiquesSecondeResidenceGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  personnesPhysiquesSecondeResidenceGet(params: {

    /**
     * Identifiant de la seconde résidence
     */
    secondeResidenceId: number;

    /**
     * Identifiant de la personne physique
     */
    personnePhysiqueId: number;
  }): Observable<PersonnesPhysiquesSecondeResidenceDto> {

    return this.personnesPhysiquesSecondeResidenceGet$Response(params).pipe(
      map((r: StrictHttpResponse<PersonnesPhysiquesSecondeResidenceDto>) => r.body as PersonnesPhysiquesSecondeResidenceDto)
    );
  }

  /**
   * Path part for operation personnesPhysiquesSecondeResidenceDelete
   */
  static readonly PersonnesPhysiquesSecondeResidenceDeletePath = '/api/personnes-physiques-seconde-residence/{secondeResidenceId}/{personnePhysiqueId}';

  /**
   * Dissocie la personne physique spécifiée de la seconde résidence spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `personnesPhysiquesSecondeResidenceDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  personnesPhysiquesSecondeResidenceDelete$Response(params: {

    /**
     * Identifiant de la seconde résidence
     */
    secondeResidenceId: number;

    /**
     * Identifiant de la personne physique
     */
    personnePhysiqueId: number;
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, PersonnesPhysiquesSecondeResidenceService.PersonnesPhysiquesSecondeResidenceDeletePath, 'delete');
    if (params) {
      rb.path('secondeResidenceId', params.secondeResidenceId, {});
      rb.path('personnePhysiqueId', params.personnePhysiqueId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Dissocie la personne physique spécifiée de la seconde résidence spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `personnesPhysiquesSecondeResidenceDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  personnesPhysiquesSecondeResidenceDelete(params: {

    /**
     * Identifiant de la seconde résidence
     */
    secondeResidenceId: number;

    /**
     * Identifiant de la personne physique
     */
    personnePhysiqueId: number;
  }): Observable<void> {

    return this.personnesPhysiquesSecondeResidenceDelete$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation personnesPhysiquesSecondeResidencePost
   */
  static readonly PersonnesPhysiquesSecondeResidencePostPath = '/api/personnes-physiques-seconde-residence/{personnePhysiqueId}';

  /**
   * Associe la personne physique spécifiée à la seconde résidence spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `personnesPhysiquesSecondeResidencePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  personnesPhysiquesSecondeResidencePost$Response(params: {

    /**
     * Identifiant de la seconde résidence
     */
    secondeResidenceId?: number;
    personnePhysiqueId: string;

    /**
     * Personne physique dans la seconde résidence spécifiée
     */
    body: PersonnesPhysiquesSecondeResidenceDto
  }): Observable<StrictHttpResponse<SecondeResidencePersonnePhysiqueDto>> {

    const rb = new RequestBuilder(this.rootUrl, PersonnesPhysiquesSecondeResidenceService.PersonnesPhysiquesSecondeResidencePostPath, 'post');
    if (params) {
      rb.query('secondeResidenceId', params.secondeResidenceId, {});
      rb.path('personnePhysiqueId', params.personnePhysiqueId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SecondeResidencePersonnePhysiqueDto>;
      })
    );
  }

  /**
   * Associe la personne physique spécifiée à la seconde résidence spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `personnesPhysiquesSecondeResidencePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  personnesPhysiquesSecondeResidencePost(params: {

    /**
     * Identifiant de la seconde résidence
     */
    secondeResidenceId?: number;
    personnePhysiqueId: string;

    /**
     * Personne physique dans la seconde résidence spécifiée
     */
    body: PersonnesPhysiquesSecondeResidenceDto
  }): Observable<SecondeResidencePersonnePhysiqueDto> {

    return this.personnesPhysiquesSecondeResidencePost$Response(params).pipe(
      map((r: StrictHttpResponse<SecondeResidencePersonnePhysiqueDto>) => r.body as SecondeResidencePersonnePhysiqueDto)
    );
  }

}
